// extracted by mini-css-extract-plugin
export default {"wording":"S_ElHDIwlkcp_ELSoawu5","header":"mn2ZNY9w99OvF5MKNN31i","menuItem":"RiToB2ksaD3JybT7pSXkm"};